export default __webpack_public_path__ + "static/media/image.we-translate-pvt-ltd.a9b0c163.png";